export const LocalStorage = {

  set(name: string, value: any): void {
    if (
      name &&
      typeof name === "string" &&
      typeof window !== "undefined" &&
      window.localStorage
    ) {
      window.localStorage.setItem(name, JSON.stringify(value));
    }
  },

  get(name: string) {
    if (name && typeof name === 'string' && typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(name);
    } 
    return null;
  },

  getValue(name: string) {
    if (name && typeof name === 'string' && typeof window !== 'undefined' && window.localStorage) {
      const val = LocalStorage.get(name);
      if (typeof val === "string" && val !== "undefined") {
        return JSON.parse(val);
      }
      return null;
    };
    return null;
  },

  remove(name: string) {
    if (name && typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem(name);
    };
  }

}
